import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import styles from "./Dashboard.module.scss";

export interface IDashboardCardProps {
    title: string;
    subtitle: string;
    value: string;
}

export default function DashboardCard(props : IDashboardCardProps) {
  return (
    <Paper className={styles.card} elevation={3}>
        <Box className={styles.headerRow}>
          <Typography className={styles.title}>{props.title}</Typography>
          <Typography className={styles.subtitle}>{props.subtitle}</Typography>
        </Box>
        <Typography className={styles.value}>{props.value}</Typography>
    </Paper>
  );
}